import React from 'react';
import ReactDOM from 'react-dom/client';
import { EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { msalInstance } from './config/msalConfig';
import { App } from './App';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

const root = ReactDOM.createRoot(rootEl);

function renderWithMsal(children: React.ReactNode) {
    root.render(
        <React.StrictMode>
            <MsalProvider instance={msalInstance}>
                <BrowserRouter>{children}</BrowserRouter>
            </MsalProvider>
        </React.StrictMode>
    );
}

async function bootstrap() {
    await msalInstance.initialize();

    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload && 'account' in event.payload) {
            msalInstance.setActiveAccount(event.payload.account!);
        }
    });

    const response = await msalInstance.handleRedirectPromise();
    if (response?.account) {
        msalInstance.setActiveAccount(response.account);
    }

    const accounts = msalInstance.getAllAccounts();
    const active = msalInstance.getActiveAccount() ?? accounts[0];

    if (active && !msalInstance.getActiveAccount()) {
        msalInstance.setActiveAccount(active);
    }
    renderWithMsal(<App />);
}

bootstrap().catch((err) => {
    console.error('MSAL bootstrap error:', err);
    renderWithMsal(
        <div style={{ padding: 16, color: '#b00020' }}>Authentication failed. Please refresh the page.</div>
    );
});
